// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"c707ba14","498":"76470135","703":"bd147f88","787":"f3130b48"}[chunkId] + ".chunk.js";
};